import React from 'react'
import './PageHeading.scss'
const PageHeading = ({ label, description }) => {
  return (
    <div className="page-heading">
      <h3 className="heading">{label}</h3>
      {description && (
        <p className="page-heading-description">{description}</p>
      )}
    </div>
  )
}

export default PageHeading
